//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.PartBuilder.js";
let d=[[[0,"DependentFileSaveAsOption",1,0],[0,"NonmasterSaveAsOption",1,0]],[[[],"Dispose",{},0,0],[[],"CreateNonmasterList",{},0,0],[["num_parts"],"GetNonmasterList",{R_:{part_filenames:""}},0,0],[["part_name"],"GetNonmasterToSaveAs",{R_:{do_save_as:''}},1,0],[["part_name","do_save_as"],"SetNonmasterToSaveAs",{},2,0],[["old_name","new_name"],"EditNonmasterNameToSaveAs",{R_:{is_name_valid:''}},2,0],[[],"Commit",{},0,0]],[]];
SPLM.PDM.PartFromPartBuilder = class extends SPLM.PDM.PartBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.PartFromPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.PartFromPartBuilder.FileSaveAs = Object.freeze({
    "Some" : "Some", "All" : "All", "None" : "None"});

export default SPLM;